<div class="workSpace">
    <div class="w3-container w3-containertemplate" style="height: 7%;">
        <!--Titulo de modulo y subtitulo-->
        <div class="w3-caja-menu padreizquierda w3-quarter">
            <div class="w3-row hijoizquierda centradoVertical">
                <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{
                        'menu.'+dataService.moduleSelect | translate }} </b></span>
                <span class="w3-text-deep-orange">&bull;</span>
                <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{
                    'menu.'+dataService.subModuleSelect| translate }} </span>
            </div>
        </div>
        <!--Filtros-->
        <div class="w3-caja-menu padreizquierda w3-rest" style="height: 100%">
            <div class="w3-half w3-row centradoVertical">

            </div>
        </div>
    </div>
    <div class="espacioForm centradoVertical">
        <!-- Seleccion cuestionario -->
        <div class="w3-row">
            <div class="w3-row w3-half">
                <div class="texto">
                    <div class="w3-right zonaTexto2"><span class="w3-right textoInputs"> {{'admin.estructura.selecCues'
                            | translate}} </span></div>
                </div>
                <div class="w3-rest">
                    <div class="zonaInput">
                        <select class="contentSelect" id="cuestionario" value="default"
                            (change)="seleccionCuestionario()">
                            <option value="default"> {{'acciones.selec' | translate}} </option>
                            @for (opt of cuestionarios; track opt.id) {
                            <option value="{{opt.id}}">{{opt.name}}</option>
                            }
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <!--Botón de agregado de componentes-->
        <div class="w3-row" style="margin-top: 2vh; margin-bottom: 1vh;">
            @if (cuesSelec + '' !== 'NaN' && cuesSelec !== undefined && cuesSelec !== 0 && !addCategory1 &&
            !addCategory2) {
            <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="addElement(undefined,1)">
                {{'admin.estructura.nuevo' | translate}}
                <mat-icon class="iconoMen">add_circle_outline</mat-icon>
            </div>
            <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="changeStatus()">
                {{'admin.estructura.finalizar' | translate}}
            </div>
            }
        </div>
        <!--Formulario de agrgado componentes-->
        @if (addCategory1) {
        <div class="w3-row">
            <app-add-category [encabezado]="'compNuev'" (eventCancel)="cancelElement()"
                (eventSave)="saveElement($event)"> </app-add-category>
        </div>
        }
        <div class="w3-row" style="width: 90%; margin-left: auto; margin-right: auto;">
            @if (cuestionarioSeleccionado !== undefined) {
                <!--Titulo de los componentes-->
                @if (cuestionarioSeleccionado.elementos.length !== 0) {
                <div class="w3-row" style="margin-top: 2vh; margin-bottom: 2vh;">
                    <span class="w3-margin-left-header w3-subtituloPrincipal"> {{ 'admin.estructura.components'| translate
                        }} </span>
                </div>
                }
                <!-- Listado de los elementos-->
                @for (c of cuestionarioSeleccionado.elementos; track c.id; let ic = $index) {
                <mat-accordion class="example-headers-align" multi>
                    @if (editCategory1 && editCategory.id === c.id) {
                        <app-add-category [element]="editCategory" [encabezado]="'compEdit'" (eventCancel)="cancelElement()"
                            (eventSave)="saveEditElement($event)"></app-add-category>
                    }@else if (!editCategory1 || editCategory.id !== c.id) {
                        <mat-expansion-panel [expanded]="step1 === ic" (opened)="step1 = ic; step2 = undefined;">
                            <!--headers-->
                            <mat-expansion-panel-header class="padingPanel" [expandedHeight]="'auto'"
                                [expandedHeight]="'auto'">
                                <mat-panel-title>
                                    {{c.name}}
                                </mat-panel-title>
                                <mat-panel-description>
                                    <div class="w3-noventa2">
                                        {{c.description}}
                                    </div>
                                    <div class="w3-rest w3-right" style="height: 100% !important;">
                                        <div class="centradoVertical">
                                            <mat-icon class="iconoMen material-icons-outlined"
                                                (click)="editElement(undefined,1,c)">edit</mat-icon>
                                            <mat-icon class="iconoMen material-icons-outlined"
                                                (click)="deleteElement(c)">delete</mat-icon>
                                        </div>
                                    </div>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <!--Botones de agrgado de preguntas o elementos-->
                            @if (!addCategory2 && !addCategory1) {
                                <div class="w3-row" style="margin-bottom: 1vh;">
                                    @if (c.questions.length === 0) {
                                        <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh;" (click)="addElement(c,2)">
                                            {{'admin.estructura.nuevo2' | translate}}
                                            <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                                        </div>
                                    }
                                </div>
                            }
                            <!--Agregado de elementos-->
                            @if (addCategory2 && elementParent.id === c.id) {
                                <div class="w3-row">
                                    <app-add-category [encabezado]="'compNuev'" (eventCancel)="cancelElement()"
                                        (eventSave)="saveElement($event)"></app-add-category>
                                </div>
                            }
                            <!--Titulo de los elementos-->
                            @if (c.elementos.length !== 0) {
                                <div class="w3-row" style="margin-top: 2vh; margin-bottom: 2vh;">
                                    <span class="w3-margin-left-header w3-subtituloPrincipal"> {{ 'admin.estructura.elements'|
                                        translate }} </span>
                                </div>
                            }
                            <!--Listado de elementos-->
                            <mat-accordion class="example-headers-align" multi>
                                @if (editCategory2 && elementParent.id === c.id) {
                                    <app-add-category [element]="editCategory" [encabezado]="'compEdit'"
                                        (eventCancel)="cancelElement()"
                                        (eventSave)="saveEditElement($event)"></app-add-category>
                                }
                                @for (e of c.elementos; track e.id; let ie = $index) {
                                    @if (!editCategory2 || editCategory.id !== e.id) {
                                        <mat-expansion-panel [expanded]="step2 === ie" (opened)="step2 = ie">
                                            <mat-expansion-panel-header class="padingPanel" [expandedHeight]="'auto'"
                                                [expandedHeight]="'auto'">
                                                <mat-panel-title>
                                                    {{e.name}}
                                                </mat-panel-title>
                                                <mat-panel-description>
                                                    <div class="w3-noventa2">
                                                        {{e.description}}
                                                    </div>
                                                    <div class="w3-rest w3-right" style="height: 100% !important;">
                                                        <div class="centradoVertical">
                                                            <mat-icon class="iconoMen material-icons-outlined"
                                                                style="margin-right: 1vw;"
                                                                (click)="editElement(c,2,e)">edit</mat-icon>
                                                            <mat-icon class="iconoMen material-icons-outlined"
                                                                style="margin-right: 1vw;"
                                                                (click)="deleteElement(e)">delete</mat-icon>
                                                        </div>
                                                    </div>
                                                </mat-panel-description>
                                            </mat-expansion-panel-header>

                                            <app-add-questions [element]="e"
                                                [addCategory]="addCategory2"></app-add-questions>
                                        </mat-expansion-panel>
                                    }
                                }
                            </mat-accordion>
                            <!--Preguntas-->
                            <app-add-questions [element]="c" [addCategory]="addCategory2"></app-add-questions>
                        </mat-expansion-panel>                   
                    }
                </mat-accordion>
                }
            }
        </div>
    </div>
</div>